import React from 'react';
import PropTypes from 'prop-types';
import { InternalLink } from 'smartsuite-ui';
import { getMultiSystemNonApiUri, getNonApiUri } from '../../utils/getUri';
import { useAdvancedSearchContext } from './AdvancedSearchContext';

export default function LinkWrapper(props) {
    const { systemManifest } = useAdvancedSearchContext();

    if (!props.hasAccess || !props.pathName) {
        return <span>{props.children}</span>;
    }

    // prettier-ignore
    const link =
        systemManifest?.length && props.destinationSystemKey
            ? getMultiSystemNonApiUri(
                props.pathName,
                props.destinationSystemKey,
                systemManifest
            )
            : getNonApiUri(props.pathName);

    return (
        <InternalLink
            canViewLink={true}
            href={link}
            openInNewTab={props.openInNewTab}
        >
            {props.children}
        </InternalLink>
    );
}

LinkWrapper.propTypes = {
    pathName: PropTypes.string.isRequired,
    destinationSystemKey: PropTypes.string,
    hasAccess: PropTypes.bool.isRequired,
    openInNewTab: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

LinkWrapper.defaultProps = {
    openInNewTab: false,
    destinationSystemKey: null,
};
